define('core/views/ClickTooltip',[
    'underscore',
    'core/views/common/HoverCard',
    'core/views/Tooltip',
], function (
    _,
    HoverCard,
    Tooltip
) {
    'use strict';

    /**
     * Implemented as a Tooltip, but overrides the show condition to only
     * show when target clicked instead of on hover. Still hides when cursor
     * is moved away from target or tooltip.
     * Must be given a template to show.
     */
    var ClickTooltip = Tooltip.extend({
        // Show on click, not on hover
        target: function ($target) {
            $target.on('click', _.bind(this.targetClicked, this, $target));
            $target.on('mouseleave', _.bind(this.leave, this));

        },

        targetClicked: function ($target) {
            if ($target)
                this.$target = $target;

            if (this._hoverState === 'in')
                return;

            this._hoverState = 'in';
            this.show();

            Tooltip.open[this.uid] = this;
        },
    }, {
        create: function (options) {
            return HoverCard.create(options.id, options, 'ClickTooltip', ClickTooltip);
        },
    });

    return ClickTooltip;
});

